"use strict";
const signalRServices_1 = require("../../common/src/signalR/signalRServices");
const alarm_1 = require("./alarm");
const defaultAlarmSettings_1 = require("./config/default/defaultAlarmSettings");
const alarmConfig_1 = require("./config/alarmConfig");
exports.ALARM_HUBSERVICEPROVIDER_ENTRY = { provide: signalRServices_1.IHUBSERVICE_TOKEN, useClass: alarm_1.InaxAlarmService, multi: true };
exports.ALARM_CONFIG_PROVIDER_ENTRY = { provide: alarmConfig_1.ALARM_CONFIG_TOKEN, useValue: defaultAlarmSettings_1.DEFAULT_ALARM_SETTINGS, multi: false };
exports.DEFAULT_ALARM_PROVIDER_ENTRIES = [
    exports.ALARM_HUBSERVICEPROVIDER_ENTRY,
    exports.ALARM_CONFIG_PROVIDER_ENTRY,
];
